$(document).ready(function() {
    // Check on document ready and initialize if the viewport width is 1024px or less.
    if ($(window).width() <= 1024) {
        $('.carousel-wrapper').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            variableWidth: true,
            draggable: true,
            swipe: true,
            edgeFriction: 0.15,
            autoplay: false,
            autoplaySpeed: 500,
            touchThreshold: 100
        });
    }

    // Re-check on window resize
    $(window).resize(function() {
        if ($(window).width() > 1024) {
            if ($('.carousel-wrapper').hasClass('slick-initialized')) {
                $('.carousel-wrapper').slick('unslick');
            }
        } else {
            if (!$('.carousel-wrapper').hasClass('slick-initialized')) {
                $('.carousel-wrapper').slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    variableWidth: true,
                    draggable: true,
                    swipe: true,
                    edgeFriction: 0.15,
                    touchThreshold: 100
                });
            }
        }
    });
  });
